import pretty from "pretty";
/**
 * Prettify an HTML script to make it more human-readable.
 * This is the web version; for Node environments, use the one from "utils-library/dist/node".
 */
export const prettifyHTML = (html) => pretty(html);
